import Cookies from 'js-cookie'
import pathToRegexp from 'path-to-regexp';

const initialState = {
    isLogging: false,
    userToken: Cookies.get("userToken"),
    userInfo: {},
    menus: [],
    routes: {},
}

export default function (state = initialState, action) {
    switch (action.type) {
        case 'AUTH_LOGGING':
            state = {...state, isLogging: true};
            break;
        case 'AUTH_LOGIN_SUCCESS':
            state = {...state, isLogging: false, loginError: null, userToken: action.payload};
            break;
        case 'AUTH_LOGIN_FAIL':
            state = {...state, isLogging: false};
            break;
        case 'AUTH_GET_INFO_SUCCESS':
            let {info, menus, routes, configs} = action.payload;
            menus = formatMenus(menus);
            routes = generateRouteData(menus, routes);
            state = {
                ...state,
                userInfo: info,
                menus: menus,
                routes: routes,
                configs: {...configs, 'report_fields': configs.report_fields.split(',')}
            };
            break;
        case 'AUTH_LOGOUT_SUCCESS':
            state = {...state, userToken: null, userInfo: {}};
            break;
        default:
            break;
    }
    return state;
}

function formatMenus(menus, parentPath = '/') {
    return menus.map((item) => {
        let {path} = item
        path = parentPath + path
        const result = {
            ...item,
            path: path
        }
        if (item.children) {
            result.children = formatMenus(item.children, path + '/')
        }
        if (result.permissions) {
            result.permissions = result.permissions.map(item => item.path)
        }
        return result
    })
}

function getFlatMenuData(menus) {
    let keys = {}
    menus.forEach(item => {
        item = {...item}
        const children = item.children
        if (children) {
            delete item.children
            keys = {...keys, ...getFlatMenuData(children)}
        }
        keys[item.path] = {...item};
    });
    return keys
}

function generateRouteData(menus, routes) {
    const flatMenus = getFlatMenuData(menus);
    Object.keys(flatMenus).forEach(menuPath => {
        const pathRegexp = pathToRegexp(menuPath);
        const routePath = Object.keys(routes).find(routePath => {
            return pathRegexp.test(routePath)
        });
        if (routePath) {
            routes[routePath] = {...routes[routePath], ...flatMenus[menuPath]}
        } else {
            routes[menuPath] = {...flatMenus[menuPath]}
        }
    });
    return routes
}